import {
  EVENT_LISTENER_METHODS_WEB,
  eventBus,
  getLocalTrack,
  isDeviceEqual,
  MEDIA_TYPE,
  updateAudioInputDevice,
  updateAudioOutputDevice,
  updateVideoInputDevice,
  useBaseStore,
} from '@cometchat/calls-sdk-core';

useBaseStore.subscribe(
  state => state.audioInputDevice,
  async (audioInputDevice, prevAudioInputDevice) => {
    const isMobileSDK = useBaseStore.getState().isMobileSDK();
    if (isMobileSDK && audioInputDevice?.deviceId !== null) {
      return;
    }
    if (audioInputDevice?.skipSubscribe) {
      return;
    }
    if (prevAudioInputDevice?.deviceId === '') {
      return;
    }
    if (audioInputDevice && prevAudioInputDevice) {
      const isMobileBrowser = useBaseStore.getState().isMobileBrowser;

      // If the device ID remains the same but the actual audio input device changes,
      // we need to dispose the track and create a new one. Otherwise, it will continue
      // using the old device. For example, during an ongoing call, if a user plugs in
      // earphones, the default device changes to earphones but the ID remains "default".
      if (
        audioInputDevice.deviceId === prevAudioInputDevice.deviceId ||
        isMobileBrowser
      ) {
        const localAudioTrack = getLocalTrack(MEDIA_TYPE.AUDIO);
        if (localAudioTrack) {
          await localAudioTrack.originalTrack?.stopStream();
        }
      }
      updateAudioInputDevice(audioInputDevice.deviceId);

      const device = useBaseStore.getState().audioInputDevice;
      if (device) {
        eventBus.publish({
          type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
            .onAudioInputDeviceChanged,
          payload: device,
        });
      }
    }
  },
  {
    equalityFn: isDeviceEqual,
  },
);

useBaseStore.subscribe(
  state => state.audioInputDevices,
  devices => {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
        .onAudioInputDevicesChanged,
      payload: devices,
    });
  },
);

useBaseStore.subscribe(
  state => state.videoInputDevices,
  devices => {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
        .onVideoInputDevicesChanged,
      payload: devices,
    });
  },
);

useBaseStore.subscribe(
  state => state.audioOutputDevices,
  devices => {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
        .onAudioOutputDevicesChanged,
      payload: devices,
    });
  },
);

useBaseStore.subscribe(
  state => state.audioOutputDevice?.deviceId,
  deviceId => {
    if (typeof deviceId === 'string') {
      updateAudioOutputDevice(deviceId);
      const device = useBaseStore.getState().audioOutputDevice;
      if (device) {
        eventBus.publish({
          type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
            .onAudioOutputDeviceChanged,
          payload: device,
        });
      }
    }
  },
);

useBaseStore.subscribe(
  state => state.videoInputDevice,
  async (videoInputDevice, prevVideoInputDevice) => {
    const isMobile = useBaseStore.getState().isMobile();
    if (isMobile && videoInputDevice?.deviceId !== null) {
      return;
    }
    if (prevVideoInputDevice && videoInputDevice) {
      updateVideoInputDevice(videoInputDevice.deviceId);
      const device = useBaseStore.getState().videoInputDevice;
      if (videoInputDevice.deviceId === prevVideoInputDevice.deviceId) {
        const localVideoTrack = getLocalTrack(MEDIA_TYPE.VIDEO);
        if (localVideoTrack) {
          await localVideoTrack.originalTrack.dispose();
        }
      }
      if (device) {
        eventBus.publish({
          type: EVENT_LISTENER_METHODS_WEB.MediaEventsListener
            .onVideoInputDeviceChanged,
          payload: device,
        });
      }
    }
  },
  {
    equalityFn: isDeviceEqual,
  },
);
